module.exports = __webpack_public_path__ + "img/icon9.885d6795.png";